//core
import React, { useState, useEffect } from "react";
import arePropsEqual from "react-fast-compare";
import { Tooltip, useMediaQuery } from "@mui/material";

//styles
import { useStyles } from "./styles";

//routes
import routes from "../../../../../navigation/routes";

//store
import { useUser } from "../../../../../store/common/user/useUser";
import { useLocation } from "react-router-dom";

interface IClickablePlayerIdProps {
  value: string | number;
  id: string | number;
}

const ClickablePlayerId = ({ value = "", id }: IClickablePlayerIdProps) => {
  const styles = useStyles();
  const mobile = useMediaQuery('(max-width:767px)');
  const location = useLocation();
  const { user } = useUser();

  const [link, setLink] = useState<string>("");

  const isFullUserList = location.pathname.includes("full-user-list");
  const isAdmin = user.user.namespace === "admin";

  useEffect(() => {
    if (isAdmin) {
      const baseRoute = isFullUserList
        ? routes.admin.agent.fullPlayers.playerAccount.root
        : routes.admin.agent.playerAccount.root;
      setLink(`${baseRoute}/${id}`);
    } else {
      setLink(`${routes.agent.agentsList.playerAccount.root}/${id}`);
    }
  }, [isAdmin, isFullUserList, id]);

  return (
    <>
      {value ? (
        mobile ? (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.text}`}
          >
            {value}
          </a>
        ) : (
          <Tooltip title={value}>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.text}`}
            >
              {value}
            </a>
          </Tooltip>
        )
      ) : (
        "—"
      )}
    </>
  );
};

export default React.memo(ClickablePlayerId, arePropsEqual);
